import apiClient from './index'
// import { getUserIdFromCookie } from '../utils';

// Purchase bulk credits
export const purchaseBulkCredits = async (purchaseData) => {
	//   const userId = getUserIdFromCookie();
	return apiClient
		.post(`/bulk-credits/purchase?cuId=${purchaseData.customerUserId}`, { purchaseData })
		.then((response) => {
			if (response) {
				return response.data
			}
			return Promise.reject()
		})
		.catch((error) => {
			console.error('Error purchasing bulk credits:', error)
			return Promise.reject(error)
		})
}

// Get user's current credit balance
// export const getUserCredits = async () => {
// //   const userId = getUserIdFromCookie();
//   return apiClient
//     .get(`/bulk-credits/balance?cuId=${userId}`)
//     .then((response) => {
//       if (response) {
//         return response.data;
//       }
//       return Promise.reject();
//     })
//     .catch((error) => {
//       console.error("Error getting user credits:", error);
//       return Promise.reject(error);
//     });
// };

// Get bulk credit packages
export const getBulkCreditPackages = async (customerUserId) => {
	//   const userId = getUserIdFromCookie();
	console.log('Calling getBulkCreditPackages API with customerUserId:', customerUserId)
	return apiClient
		.post(`/bulk-credits/packages?cuId=${customerUserId}`, { customerUserId })
		.then((response) => {
			if (response) {
				return response.data
			}
			return Promise.reject()
		})
		.catch((error) => {
			console.error('Error getting bulk credit packages:', error)
			return Promise.reject(error)
		})
}

// Update auto-renew settings
// export const updateAutoRenewSettings = async (settings) => {
// //   const userId = getUserIdFromCookie();
//   return apiClient
//     .put(`/bulk-credits/auto-renew?cuId=${userId}`, settings)
//     .then((response) => {
//       if (response) {
//         return response.data;
//       }
//       return Promise.reject();
//     })
//     .catch((error) => {
//       console.error("Error updating auto-renew settings:", error);
//       return Promise.reject(error);
//     });
// };

// Update credit balance
export const updateCreditBalance = async (newBalance, customerUserId) => {
	//   const userId = getUserIdFromCookie();
	console.log('Calling updateCreditBalance API with customerUserId:', customerUserId, 'newBalance:', newBalance)
	return apiClient
		.put(`/bulk-credits/balance?cuId=${customerUserId}`, { newBalance, customerUserId })
		.then((response) => {
			if (response) {
				return response.data
			}
			return Promise.reject()
		})
		.catch((error) => {
			console.error('Error updating credit balance:', error)
			return Promise.reject(error)
		})
}
